// extracted by mini-css-extract-plugin
module.exports = {"txCreation":"styles_txCreation__MAiur","txSummary":"styles_txSummary__g95ve"};